function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import TimeAgoComponent from "react-timeago";
import en from "react-timeago/lib/language-strings/en-short";
import buildFormatter from "react-timeago/lib/formatters/buildFormatter";
import tinytime from "tinytime";
const formatter = (...args)=>{
    const [_, unit] = args;
    if (unit === "second") return "just now";
    return buildFormatter(_objectSpread({}, en, {
        suffixAgo: "ago"
    }))(...args);
};
export const time = tinytime("{MM} {DD}, {YYYY}, {h}:{mm}{a}");
function TimeAgo(props) {
    const { date  } = props, rest = _objectWithoutProperties(props, [
        "date"
    ]);
    const dateObject = new Date(date);
    /*
   * Because of SSR, we cannot render timezone-specific date on initial render
   * otherwise we get errors like:
   *
   * `Warning: Prop `title` did not match. Server: "Apr 1, 2018, 7:32PM" Client: "Apr 1, 2018, 8:32PM"`
   *
   * So we use the ISO timestamp until the component is mounted
   */ const [mount, setMount] = useState(false);
    useEffect(()=>{
        setMount(true);
    }, []);
    return /*#__PURE__*/ _jsx(TimeAgoComponent, _objectSpread({
        formatter: formatter,
        component: "span",
        date: date,
        title: mount ? time.render(dateObject) : dateObject.toISOString()
    }, rest));
}
TimeAgo.propTypes = {
    date: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date),
        PropTypes.number, 
    ]).isRequired
};
export default TimeAgo;
